import { useEffect, useRef } from 'react';
import { useWorkspaceStore, setWorkspaces } from '../store/workspaceStore';
import { getAllWorkspaceGitLinks } from '../services/accountsStore';

/**
 * Hydrates persisted git remote links onto workspaces once, after they first
 * load. Each workspace keeps its own `git` meta if already present. Runs a
 * single time (guarded by the ref). Extracted verbatim from App.
 */
export function useGitLinksHydration() {
  const workspaces = useWorkspaceStore((s) => s.workspaces);
  const gitLinksHydratedRef = useRef(false);

  useEffect(() => {
    if (gitLinksHydratedRef.current) return;
    if (!workspaces || workspaces.length === 0) return;
    (async () => {
      try {
        const links = await getAllWorkspaceGitLinks();
        if (links && Object.keys(links).length > 0) {
          setWorkspaces((prev) =>
            prev.map((w) =>
              links[String(w.id)] && !w.git ? { ...w, git: links[String(w.id)] } : w
            )
          );
        }
      } catch {
        // ignore
      } finally {
        gitLinksHydratedRef.current = true;
      }
    })();
  }, [workspaces]);
}
